import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import type {SxProps} from '@mui/material';
import Button from '@mui/material/Button';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import type {SlamPointCloud} from '@/domain/entities/SlamPointCloud';
import type {UavPointCloud} from '@/domain/entities/UavPointCloud';

//TYPES
type Props = {
  pointCloud?: UavPointCloud | SlamPointCloud;
  canUpload: boolean;
  onUploadClick: () => void;
  onInfoClick: () => void;
  disabled?: boolean;
};

const PointCloudsAddInfoButton: FC<Props> = ({pointCloud, canUpload, onUploadClick, onInfoClick, disabled = false}) => {
  const {t} = useTranslation();

  return (
    <>
      {pointCloud ? (
        <Button
          startIcon={<InfoOutlinedIcon />}
          variant="outlined"
          onClick={onInfoClick}
          sx={styles.uploadingButon}
          disabled={disabled}
        >
          {t('pointClouds.title')}
        </Button>
      ) : (
        canUpload && (
          <Button startIcon={<FileUploadOutlinedIcon />} variant="outlined" onClick={onUploadClick} disabled={disabled}>
            {t('pointClouds.title')}
          </Button>
        )
      )}
    </>
  );
};
export default PointCloudsAddInfoButton;

const styles: Record<string, SxProps> = {
  uploadingButon: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    minWidth: 'max-content',
  },
};
